/**
 * Login Callback Page
 * 
 * Feature: 033-auth-complete
 * Description: Handle OAuth redirect from Microsoft Entra ID
 * Constitution: v1.11.0
 */

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';

export const LoginCallback: React.FC = () => {
  const { instance } = useMsal();
  const navigate = useNavigate();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        // handleRedirectPromise was already called in initializeMsal()
        // Just check if we have an authenticated account
        const accounts = instance.getAllAccounts();
        if (accounts.length > 0) {
          navigate('/', { replace: true });
        } else {
          // Try handleRedirectPromise in case it wasn't consumed yet
          const response = await instance.handleRedirectPromise();
          if (response) {
            instance.setActiveAccount(response.account);
            navigate('/', { replace: true });
          } else {
            navigate('/login', { replace: true });
          }
        }
      } catch (error) {
        console.error('Login callback error:', error);
        navigate('/login', { replace: true });
      }
    };

    handleCallback();
  }, [instance, navigate]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
        <p className="text-lg text-gray-600">Completing sign in...</p>
      </div>
    </div>
  );
};
